import { Dispatch } from 'react-redux';
import { Action } from '../../../actions';
import { Api } from '../../../typings/api';
import ApiUtils from '../../../utils/api';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { receiveResolutions, receiveDriveItems } from '../actions';
import LocalStorageManager from '../../../utils/localStorage/manager';

const MAXIMUM_LAST_VISIT_DAYS = 30;

export enum NewDriveItemActionKeys {
	REQUEST_NEW_DRIVE_ITEMS = '@@newDriveItem/REQUEST_NEW_DRIVE_ITEMS',
	RECEIVE_NEW_DRIVE_ITEMS = '@@newDriveItem/RECEIVE_NEW_DRIVE_ITEMS',
	INIT_LAST_VISIT_DATE = '@@newDriveItem/INIT_LAST_VISIT_DATE',
}

interface RequestNewDriveItemsAction extends Action {
	type: NewDriveItemActionKeys.REQUEST_NEW_DRIVE_ITEMS;
}

interface ReceiveNewDriveItemsAction extends Action {
	type: NewDriveItemActionKeys.RECEIVE_NEW_DRIVE_ITEMS;
	driveItemIds: number[];
	lastCheckDate: Date;
}

interface InitLastVisitDateAction extends Action {
	type: NewDriveItemActionKeys.INIT_LAST_VISIT_DATE;
	lastVisitDate: Date;
}

export type NewDriveItemAction = RequestNewDriveItemsAction | ReceiveNewDriveItemsAction | InitLastVisitDateAction;

const compareByCreationDateDesc = (a: Api.DriveItem, b: Api.DriveItem) => {
	const valueA = Utils.parseDate(a.creationDate).getTime();
	const valueB = Utils.parseDate(b.creationDate).getTime();
	return valueB - valueA;
};

export const fetchNewDriveItems = () =>
								(dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void | {}> => {
	const { newDriveItems } = getState();
	const { lastVisitDate } = newDriveItems;

	dispatch(requestNewDriveItems());
	if (lastVisitDate) {
		const currentDate = new Date();
		const maximumVisitDate = new Date(currentDate.getTime() - (1000 * 3600 * 24 * MAXIMUM_LAST_VISIT_DAYS));
		const resolvedLastVisitDate = maximumVisitDate > lastVisitDate ? maximumVisitDate : lastVisitDate;

		return ApiUtils.getNewContents(resolvedLastVisitDate)
			.then(contentBlock => {
				const driveItems = Object.keys(contentBlock.metas).map(strindId => {
					const driveItemId = parseInt(strindId, 10);
					return contentBlock.metas[driveItemId];
				});

				driveItems.sort(compareByCreationDateDesc);
				const driveItemIds = driveItems.map(driveItem => driveItem.id);

				if (contentBlock.resolutions) {
					dispatch(receiveResolutions(contentBlock.resolutions));
				}
				dispatch(receiveDriveItems(contentBlock.metas));
				return dispatch(receiveNewDriveItems(driveItemIds));
			});
	} else {
		dispatch(receiveNewDriveItems([]));
		dispatch(setLastVisitDate());
	}
	return Promise.resolve();
};

const requestNewDriveItems = (): RequestNewDriveItemsAction => ({ type: NewDriveItemActionKeys.REQUEST_NEW_DRIVE_ITEMS });

export const loadPreviousLastVisitDate = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const lastVisitDate = LocalStorageManager.getLastVisitDate();
	if (lastVisitDate) {
		dispatch({
			type: NewDriveItemActionKeys.INIT_LAST_VISIT_DATE,
			lastVisitDate: lastVisitDate,
		});
	}
};

export const setLastVisitDate = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const { lastCheckDate } = getState().newDriveItems;
	if (lastCheckDate) {
		LocalStorageManager.setLastVisitDate(lastCheckDate);
	}
};

const receiveNewDriveItems = (driveItemIds: number[]): ReceiveNewDriveItemsAction => {
	return ({
		type: NewDriveItemActionKeys.RECEIVE_NEW_DRIVE_ITEMS,
		driveItemIds,
		lastCheckDate: new Date()
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/New/actions.ts